import { graphql } from "../gql";

export const getAuditRuleQueryDoc = graphql(`
  query getAuditRule($id: String!) {
    auditRuleV2(id: $id) {
      id
      name
      status
      selectCodeStr
      evaluateCodeStr
      ruleCodeTestResults
      createdAt
      createdBy
      isTestRunning
      hasPreviousTestResults
      publishability {
        isPublishable
        reasons {
          code
          message
        }
      }
    }
  }
`);
